import { render, staticRenderFns } from "./TermsHero.vue?vue&type=template&id=6529aaea&scoped=true&"
import script from "./TermsHero.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TermsHero.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TermsHero.vue?vue&type=style&index=0&id=6529aaea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6529aaea",
  null
  
)

export default component.exports